// @flow

import styled, { css } from 'styled-components';
import React, { type Node } from 'react';

import { theme } from '../../theme';

import copyIconSrc from './copy-icon.svg';
import copiedIconSrc from './copied-icon.svg';
import { useCopyToClipboard } from './use-copy';

type Props = {
  children?: Node,
  size?: string,
  value: string,
};

export function CopyToClipboardIcon({ children, size, value }: Props): Node {
  const [Clipboard, copied, handleClick] = useCopyToClipboard();
  return (
    <CopyIcon
      as={Clipboard}
      copied={copied}
      data-clipboard-text={value}
      onClick={handleClick}
      outline={!copied}
      size={size}
    >
      {children}
    </CopyIcon>
  );
}

export const CopyIcon = styled.i`
  background-color: transparent;
  border: 0;
  outline: 0;
  white-space: nowrap;

  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;

  ::after {
    margin-left: .2em;
    display: inline-block;
    vertical-align: top;
    content: '';

    ${({ size = '1.2em' }) => css`
      padding: calc(${size} / 2);
    `}

    background-color: transparent;
    background-image: url(${copyIconSrc});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    ${({ copied }) => copied && css`
        background-color: ${theme.colors.green(50)};
        background-image: url(${copiedIconSrc});
        border-radius: 50%;
        background-size: 50%;
    `}
  }
`;
